import React from 'react'
import { SvgIcon } from '../svg-icon'

import styles from './expand-left-icon.module.css'

/**
 * Renders an expand left icon, which is basically just
 * a rotated and scaled AngleDownIcon.
 *
 * @see SvgIcon for propTypes
 *
 * @example
 * <ExpandLeftIcon width={12} />
 */
const ExpandLeftIcon = props => (
    <SvgIcon className={styles['expand-left-icon']} viewBox="0 5 18 18" {...props}>
        <path
            d={`M16.797 11.5q0 0.203-0.156 0.359l-7.281 7.281q-0.156 0.156-0.359
            0.156t-0.359-0.156l-7.281-7.281q-0.156-0.156-0.156-0.359t0.156-0.359l0.781-0.781q
            0.156-0.156 0.359-0.156t0.359 0.156l6.141 6.141 6.141-6.141q0.156-0.156 0.359-0.156t0.359
            0.156l0.781 0.781q0.156 0.156 0.156 0.359z`}
        />
    </SvgIcon>
)

export { ExpandLeftIcon }
